import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { beliefQuote } from "@/lib/gatewayContent";
import SanctuaryHeader from "@/components/gateway/SanctuaryHeader";
import { LayoutGrid } from "lucide-react";

const options = [
  { key: "emptiness", title: "Emptiness", sub: "Low Energy / I need an anchor", to: "/gateway/emptiness" },
  { key: "chaos", title: "Chaos", sub: "Racing Thoughts / I need to dump my mind", to: "/gateway/chaos" },
  { key: "readiness", title: "Readiness", sub: "High Energy / I am ready to build structure", to: "/gateway/readiness" },
];

const Gateway = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const quote = beliefQuote(user?.belief_filter);

  return (
    <div className="min-h-screen relative overflow-hidden flex flex-col items-center justify-center px-6"
      style={{ background: "radial-gradient(ellipse at 50% 35%, #1c2b33 0%, #101a20 55%, #0a1116 100%)" }}
      data-testid="gateway-screen">

      <SanctuaryHeader tone="dark" className="absolute top-5 left-5 z-20" />

      <button onClick={() => navigate(user ? "/app" : "/register")} data-testid="gateway-toolkit"
        className="absolute top-5 right-5 flex items-center gap-2 text-white/40 hover:text-white/80 text-xs transition-colors">
        <LayoutGrid className="w-4 h-4" /> {user ? "Full toolkit" : "Sign up"}
      </button>

      {/* Breathing pulse */}
      <div className="relative mb-14 flex items-center justify-center" aria-hidden>
        <div className="absolute w-40 h-40 rounded-full bg-teal-300/10 animate-breathe" style={{ animationDuration: "8s" }} />
        <div className="absolute w-28 h-28 rounded-full bg-teal-200/10 animate-breathe" style={{ animationDuration: "8s", animationDelay: "0.6s" }} />
        <div className="w-16 h-16 rounded-full bg-teal-100/20 animate-breathe" style={{ animationDuration: "8s", animationDelay: "1.2s" }} />
      </div>

      <p className="text-white/70 font-light tracking-wide text-lg mb-10 text-center" data-testid="gateway-greeting">
        How is your heart feeling right now?
      </p>

      <div className="w-full max-w-sm space-y-4">
        {options.map((o) => (
          <button key={o.key} onClick={() => navigate(o.to)} data-testid={`gateway-${o.key}`}
            className="w-full text-left rounded-3xl px-6 py-5 border border-white/15 bg-white/5 backdrop-blur-md hover:bg-white/10 hover:border-white/25 transition-all duration-500">
            <span className="block text-white font-serif text-2xl">{o.title}</span>
            <span className="block text-white/45 text-sm mt-0.5">{o.sub}</span>
          </button>
        ))}
      </div>

      <p className="absolute bottom-6 left-0 right-0 text-center text-white/25 text-xs px-8 font-light" data-testid="gateway-footer">{quote}</p>

      <button onClick={() => navigate("/sounds")} data-testid="gateway-sounds"
        className="mt-8 text-white/40 hover:text-white/75 text-sm underline underline-offset-4 transition-colors">
        Just explore the sounds
      </button>
    </div>
  );
};

export default Gateway;
